import type { DocumentNameTableCellFragment } from "../client/generated";
import { Link } from "react-router";
import { routingPaths } from "../navigation/constants";
import { Icon } from "@mdi/react";
import { mdiAccountMultiple } from "@mdi/js";
import { DocumentTableCell } from "./DocumentTableCell";
import { DocumentTags } from "./DocumentTags";

type Props = {
  fragment: DocumentNameTableCellFragment;
};

export function DocumentNameTableCell({ fragment }: Props) {
  return (
    <DocumentTableCell className="flex flex-col gap-2">
      <Link to={routingPaths.document(fragment.id)}>
        {fragment.name}{" "}
        {fragment.members.total > 1 && (
          <Icon size="1rem" path={mdiAccountMultiple} className="inline" />
        )}
      </Link>
      <DocumentTags fragment={fragment} />
    </DocumentTableCell>
  );
}
